/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Lead_CreatedInputs */

const cs_messages_lead_created = /** @type {(inputs: Messages_Lead_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead vytvořen z této zprávy.`)
};

const en_messages_lead_created = /** @type {(inputs: Messages_Lead_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead created from this message.`)
};

/**
* | output |
* | --- |
* | "Lead created from this message." |
*
* @param {Messages_Lead_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_lead_created = /** @type {((inputs?: Messages_Lead_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Lead_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_lead_created(inputs)
	return cs_messages_lead_created(inputs)
});